import { get, AuthProvider } from '../pt/utils/http-service';
import { ClientData } from '../pt/utils/interfaces';

export async function getTrainers(auth: AuthProvider): Promise<string[]> {
  const res = await get('superadmin/accounts', auth);
  if (res.status === 403) throw new Error('Not a superadmin');
  return res.json();
}

export async function getTrainerClients(email: string, auth: AuthProvider): Promise<ClientData[]> {
  const res = await get(`superadmin/accounts/${encodeURIComponent(email)}/profiles`, auth);
  if (res.status === 403) throw new Error('Not a superadmin');
  return res.json();
}
